import { Component } from '@angular/core';

@Component({
  selector: 'app-dev-tools-page',
  standalone: false,
  templateUrl: './dev-tools-page.component.html',
  styleUrl: './dev-tools-page.component.scss',
})
export class DevToolsPageComponent {}
